import "../../Styling/section.scss";

//stlying
import "./about.scss";
import "../../Styling/section.scss";

//asset imports
import profilePic from "../../Assets/Images/goose.jpg";

function About() {
    return (
        <section>
            <h2 className="aboutHeader">About Shen</h2>
            <article className="about-card">
                <div className="aboutImgBox">
                    <img className="aboutImgBox__image" src={profilePic} alt="Image of Shen"/>
                </div>
                <p className="about-card__content">
                Shen Tao immigrated to Canada at an early age, and grew up inspired by both Chinese and Western stories. She has wanted to be a writer for as long as she can remember. Her debut novel, <a href="https://linktr.ee/ThePoetEmpress" target="new"><em>The Poet Empress</em></a>,  is an epic fantasy about poetry magic and a woman who learns to read in secret to change a dynasty.
                </p>
            </article>
        </section>
    )
}

export default About;
